export function parallax(root = document) {
    const visuals = root.querySelectorAll('[data-parallax]');
    if (!visuals.length) return;

    const media = gsap.matchMedia();

    media.add('(prefers-reduced-motion: no-preference)', () => {
        visuals.forEach((visual) => {
            const target = visual.querySelector('img, video');
            if (!target) return;

            const amount = parseFloat(visual.dataset.parallax) || 8;

            gsap.fromTo(target, {
                yPercent: -amount,
            }, {
                yPercent: amount,
                ease: 'none',
                scrollTrigger: {
                    trigger: visual,
                    start: 'top bottom',
                    end: 'bottom top',
                    scrub: true,
                    invalidateOnRefresh: true,
                },
            });
        });
    });

    return () => media.revert();
}